//===========================================================================
// You can update the URL in the history with this class.
// This is useful for ajax loads.
// Just add a class of js-update-url to your link or form.
// See the AjaxLoader class for how to set up ajax loads.
//===========================================================================

export default class UrlUpdater {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Update URL on link click
  //===========================================================================

  updateUrlOnLinkClick(e) {
    const $target = $(e.currentTarget);

    if ($target.is('a')) {
      let href = $target[0] ? $target[0].href : null;

      e.preventDefault();

      if (href && href !== '#') {
        href = href.split('?view=')[0] || '';
        href = href.split('&view=')[0] || '';
        this.updateUrl($target[0].href);
      }
    }
  }

  //===========================================================================
  // Update URL on form submit
  //===========================================================================

  updateUrlOnFormSubmit(e) {
    const $target = $(e.currentTarget);

    if ($target.is('form')) {
      let action = $target[0] ? $target[0].action : '';
      let search = $target.serialize();
      let url    = action + '?' + search;

      e.preventDefault();

      if (action && search) {
        this.updateUrl(url);
      }
    }
  }

  //===========================================================================
  // Update URL (Replacestate)
  //===========================================================================

  updateUrl(newUrl) {
    try {
      window.history.replaceState({}, newUrl, newUrl);
    } catch(e) {
      console.log('ReplaceState Error');
      return;
    }
  }

  //===========================================================================
  // Add new page for a history change (Pushstate)
  //===========================================================================

  historyChange(newUrl) {
    try {
      window.history.pushState({}, newUrl, newUrl);
      $('link[rel="canonical"]').attr('href', newUrl);
    } catch(e) {
      console.log('Pushstate Error');
      return;
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-update-url', this.updateUrlOnLinkClick.bind(this));
    $(document).on('submit', '.js-update-url', this.updateUrlOnFormSubmit.bind(this));
  }
}
